export default __webpack_public_path__ + "static/media/index-rates.a4897d09.svg";